import { Link } from "react-router-dom";
import { USER_ALREADY_EXISTS } from "./emailVerification";

const EmailTakenHint = ({ message }) => {
    if (message !== USER_ALREADY_EXISTS) {
        return message || null;
    }
    return (
        <>
            {USER_ALREADY_EXISTS}. <Link to="/login">Log in</Link>
            {" or use your "}
            <Link to="/invite">invite / temp password</Link>.
        </>
    );
};

export default EmailTakenHint;
